export const SUBSCRIPTIONS_LIST_SUCCESS = "SUBSCRIPTIONS_LIST_SUCCESS";
export const SUBSCRIPTIONS_INFO_SUCCESS = "SUBSCRIPTIONS_INFO_SUCCESS";
export const SUBSCRIPTIONS_CREATE_SUCCESS = "SUBSCRIPTIONS_CREATE_SUCCESS";
export const SUBSCRIPTIONS_UPDATE_SUCCESS = "SUBSCRIPTIONS_UPDATE_SUCCESS";
export const SUBSCRIPTIONS_DELETE_SUCCESS = "SUBSCRIPTIONS_DELETE_SUCCESS";
export const SUBSCRIPTIONS_STATUS_SUCCESS = "SUBSCRIPTIONS_STATUS_SUCCESS";
export const CLEAR_SUBSCRIPTIONS_INFO = "CLEAR_SUBSCRIPTIONS_INFO";
